// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"14989394","793":"14989394","3359":"14989394","9910":"8045e81a"}[chunkId] + ".chunk.css";
};